import { useState, useRef, useEffect } from "react";
import {
  Zap,
  FilePlus,
  UserPlus,
  PackagePlus,
  ShoppingCart,
  ChevronRight, // Importamos la flecha
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const AccesosRapidos = () => {
  const [open, setOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null); // Estado para el hover
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const items = [
    {
      icon: <FilePlus size={20} />,
      title: "Nueva Factura",
      desc: "Crear factura de venta",
      action: () => navigate("/facturas/nueva"),
      color: "#3b82f6",
    },
    {
      icon: <UserPlus size={20} />,
      title: "Nuevo Cliente",
      desc: "Registrar nuevo cliente",
      action: () => navigate("/clientes/nuevo"),
      color: "#22c55e",
    },
    {
      icon: <PackagePlus size={20} />,
      title: "Nuevo Producto",
      desc: "Agregar producto al inventario",
      action: () => navigate("/productos/nuevo"),
      color: "#6366f1",
    },
    {
      icon: <ShoppingCart size={20} />,
      title: "Orden de Compra",
      desc: "Nueva orden de compra",
      action: () => navigate("/ordenes/nueva"),
      color: "#a855f7",
    },
  ];

  return (
    <div ref={ref} style={{ position: "relative" }}>
      {/* BOTÓN RAYO */}
      <button
        onClick={() => setOpen((v) => !v)}
        style={{
          width: 45,
          height: 45,
          borderRadius: "50%",
          border: "none",
          background: "var(--accent)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          flexShrink: 0,
        }}
      >
        <Zap size={20} />
      </button>

      {/* DROPDOWN */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: 52,
            right: 0,
            width: 300,
            background: "#fff",
            borderRadius: 14,
            boxShadow: "0 20px 40px rgba(0,0,0,.15)",
            border: "1px solid #e5e7eb",
            zIndex: 200,
          }}
        >
          {/* HEADER */}
          <div
            style={{
              // Cambiamos el padding para alinear el icono con los de abajo
              padding: "14px 20px",
              display: "flex",
              alignItems: "center",
              gap: 12,
              borderBottom: "1px solid #eee",
            }}
          >
            <div
              style={{
                width: 36, // Mismo ancho que los de abajo
                height: 36, // Misma altura
                borderRadius: 10, // Mismo radio de borde
                background: "var(--accent)",
                color: "var(--accent-contrast, #fff)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0, // Evita que se deforme
              }}
            >
              <Zap size={20} /> {/* Mismo tamaño de icono que los de abajo */}
            </div>

            <strong style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>
              Acciones Rápidas
            </strong>
          </div>

          {/* ITEMS CON PADDING PARA EL HOVER */}
          <div style={{ padding: "8px" }}>
            {items.map((item, i) => (
              <button
                key={i}
                onClick={() => {
                  item.action();
                  setOpen(false);
                }}
                onMouseEnter={() => setHoveredIndex(i)}
                onMouseLeave={() => setHoveredIndex(null)}
                style={{
                  width: "100%",
                  border: "none",
                  borderRadius: 10,
                  // Aquí está el truco: usamos el color del item + '15' (que es ~8% de opacidad en hex)
                  background:
                    hoveredIndex === i ? `${item.color}15` : "transparent",
                  padding: "10px 12px",
                  display: "flex",
                  gap: 12,
                  alignItems: "center",
                  cursor: "pointer",
                  textAlign: "left",
                  transition: "all 0.2s ease",
                }}
              >
                <div
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    // El icono mantiene un fondo un poco más notable o puedes dejarlo igual
                    background:
                      hoveredIndex === i
                        ? `${item.color}25`
                        : `${item.color}15`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: item.color,
                    flexShrink: 0,
                    transition: "all 0.2s ease",
                  }}
                >
                  {item.icon}
                </div>

                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: hoveredIndex === i ? item.color : "#111827",
                      transition: "color 0.2s",
                    }}
                  >
                    {item.title}
                  </div>
                  <div style={{ fontSize: 12, color: "#6b7280" }}>
                    {item.desc}
                  </div>
                </div>

                {/* FLECHITA dinámica con el color del item */}
                <div
                  style={{
                    color: item.color, // La flecha también toma el color del item
                    opacity: hoveredIndex === i ? 0.7 : 0,
                    transform:
                      hoveredIndex === i ? "translateX(0)" : "translateX(-5px)",
                    transition: "all 0.2s",
                  }}
                >
                  <ChevronRight size={18} />
                </div>
              </button>
            ))}
          </div>

          {/* FOOTER */}
          <div
            style={{
              padding: 12,
              fontSize: 11,
              textAlign: "center",
              color: "#9ca3af",
              borderTop: "1px solid #eee",
            }}
          >
            Acceso rápido a funciones frecuentes
          </div>
        </div>
      )}
    </div>
  );
};

export default AccesosRapidos;
